<template>
  <div class="vip">
    <c-nav></c-nav>
    <div class="container">
      <div class="logo"></div>
      <div class="title"></div>
      <div class="content">
        <div class="header t-a-c">
          <div class="a-text-15 a-text-bold">购买火车票就返现</div>
          <div class="a-text-12">每年乘车>5次的人都应该买</div>
        </div>
        <main-priority></main-priority>
        <!--more-priority></more-priority-->
      </div>
      <div class="vipInstruction t-a-c a-text-13" @click="gotoVIPInstruction">会员福利说明</div>
      <div class="tip a-text-15 t-a-c">买到就是赚到，真返现，不套路！</div>
      <div class="open fx-center" @click="gotoOpenVip">
        <div class="vipOpen t-a-c fx-center">
          <div class="a-text-20 desc a-text-bold">开通钻石会员&nbsp;&nbsp;199/年</div>
          <!-- <div class="a-text-18 price">199/年</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mainPriority from "./components/mainPriority";
import morePriority from "./components/morePriority";
import ga from "@/utils/tracker.js";

const queryString = require("query-string");

export default {
  data() {
    return {
      authphone: ""
    };
  },
  components: {
    mainPriority,
    morePriority
  },
  methods: {
    gotoOpenVip() {
      ga.track("huaweiVIP", "clickOpenVIP", "browser");
      this.$router.push({
        path: "/vipCard/confirmOpen",
        query: {
          authphone: this.authphone
        }
      });
    },
    gotoVIPInstruction() {
      this.$router.push({
        path: "/vipCard/VIPInstruction"
      });
    }
  },
  mounted() {
    this.$updateTitle("能赚钱的会员");

    const parsed = queryString.parse(location.search);
    if (parsed.authphone) {
      this.authphone = parsed.authphone;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/_vars.scss";
@import "./style/common.scss";
.vip {
  .container {
    width: 100%;
    padding-bottom: 104 * $px;
    //height: 1066 * $px;
    background: linear-gradient(180deg, #555c80, #2c2d43);
    .logo {
      width: 218 * $px;
      height: 44 * $px;
      @include bg("img_logo@3x.png");
    }
    .title {
      width: 100%;
      height: 258 * $px;
      @include bg("banner@3x.png");
      background-position: center center;
    }
    .content {
      width: 347 * $px;
      //height: 589 * $px;
      background-color: #fff;
      border-radius: 12 * $px;
      margin: 5 * $px auto;
      .header {
        width: 222 * $px;
        height: 43 * $px;
        @include bg("bg_title@3x.png");
        margin: 0 auto;
        transform: translateY(-6 * $px);
        color: #93632d;
      }
    }
    .vipInstruction {
      color: #ecc17d;
      margin-top: 14 * $px;
    }
    .tip {
      color: #fff;
      margin-top: 20 * $px;
    }
    .open {
      width: 100%;
      height: 84 * $px;
      background-color: #1c1c2d;
      position: fixed;
      bottom: 0;
      .vipOpen {
        @include bg("bg_button@3x.png");
        width: 347 * $px;
        height: 60 * $px;
        .desc {
          // margin-top: 10*$px;
          color: #8e5c22;
        }
        .price {
          color: #aa763b;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/huaweiVIP/index.vue